const OSS_URL = 'https://utm-oss.oss-cn-guangzhou.aliyuncs.com'

export function formatImage(url) {
    if (!url) return ''
    // 如果已经是完整URL，直接返回
    if (url.startsWith('http')) return url
    // 拼接OSS域名
    return `${OSS_URL}/${url}`
}
